<template>
  <svg width="28" height="29" viewBox="1.5 3 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>search-menu</title>
    <g id="Search-menu">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.60156 10.5312V21.5918H16.5846C17.1369 21.5918 17.5846 22.0395 17.5846 22.5918C17.5846 23.1441 17.1369 23.5918 16.5846 23.5918H3.60156V6.97482C3.60156 5.87052 4.49672 4.97461 5.60156 4.97461H11.1631C11.8858 4.97461 12.5522 5.36443 12.9064 5.99431L14.333 8.53125H22.334C23.4386 8.53125 24.334 9.42668 24.334 10.5312V18.1772C24.334 18.7295 23.8863 19.1772 23.334 19.1772C22.7817 19.1772 22.334 18.7295 22.334 18.1772V10.5312H5.60156ZM12.0385 8.53125L11.1631 6.97461L5.60156 6.97461V8.53125H12.0385Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.4205 18.6567C19.904 17.9949 20.1895 17.1792 20.1895 16.2969C20.1895 14.0856 18.3968 12.293 16.1855 12.293C13.9743 12.293 12.1816 14.0856 12.1816 16.2969C12.1816 18.5082 13.9743 20.3008 16.1855 20.3008C16.7861 20.3008 17.3558 20.1686 17.867 19.9316L20.8925 22.9571C21.283 23.3476 21.9162 23.3476 22.3067 22.9571C22.6972 22.5666 22.6972 21.9334 22.3067 21.5429L19.4205 18.6567ZM16.1855 18.3008C17.2923 18.3008 18.1895 17.4036 18.1895 16.2969C18.1895 15.1901 17.2923 14.293 16.1855 14.293C15.0788 14.293 14.1816 15.1901 14.1816 16.2969C14.1816 17.4036 15.0788 18.3008 16.1855 18.3008Z"
      />
    </g>
  </svg>
</template>
